<template>
  <vx-card :title="$t('reports.mental_health.TOP_STRESSORS.title')">
    <vs-row v-if="extractedData" vs-align="center" vs-justify="center">
      <vs-col vs-w="12">
        <vue-apex-charts height="200" type="bar" :options="extractedData.chartOptions" :series="extractedData.series"></vue-apex-charts>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
export default {
  name: 'mental-health-top-stressor-card',
  props: {
    data: Object
  },
  data () {
    return {
      extractedData: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const topStressors = allTime.nested.find(n => n.name === 'MAIN_STRESSORS');
        const total = topStressors.buckets.map(b => b.count).reduce((a, b) => a + b, 0);
        this.extractedData = {
          series: [
            {
              name: this.$t('reports.global.members'),
              data: topStressors.buckets.map(b => {
                return {
                  x: b.key,
                  y: b.count
                };
              })
            }
          ],
          chartOptions: {
            chart: {
              type: 'bar',
              toolbar: {
                show: false
              }
            },
            colors: [
              '#72359b',
              '#a22d94',
              '#c92886',
              '#e73073',
              '#fb475d',
              '#ff6545',
              '#ff852b',
              '#ffa600',
              '#fbddbe'
            ],
            plotOptions: {
              bar: {
                endingShape: 'rounded',
                columnWidth: '45%',
                horizontal: true,
                distributed: true
              }
            },
            fill: {
              opacity: .8
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              forceNiceScale: true,
              labels: {
                formatter (value) {
                  return Math.round(value) === value ? `${value.toFixed(0)}` : '';
                }
              }
            },
            tooltip: {
              enabled: true,
              x: {
                show: true
              },
              y: {
                formatter (val) {
                  return `${val} (${((val / total) * 100).toFixed(1)}%)`;
                },
                title: {
                  formatter: (seriesName) => `${seriesName}`
                }
              }
            },
            legend: {
              show: false
            }
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
